import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { Market } from '../models/market'
import { TypeSupport } from '../models/type-support'
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
  providedIn: 'root',
})
export class TypeSupportService {
  public API_URL: string;

  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.API_URL = appConfig.urlApi;
  }

  getTypeSupportById(idTypeSupport: number): Observable<any> {
    const url = this.API_URL + '/Supports/' + idTypeSupport;
    return this.http.get<any>(url);
  }

  getTypeSupportByIdMarket(idMarket: number): Observable<any> {
    const url = this.API_URL + '/Supports?id=' + idMarket;
    return this.http.get<any>(url);
  }

  postTypeSupport(typeSupport: TypeSupport): Observable<any> {
    const url = this.API_URL + '/Supports';
    return this.http.post<any>(url, typeSupport);
  }

  updateTypeSupport(typeSupport: TypeSupport): Observable<any> {
    const url = this.API_URL + '/Supports/' + typeSupport.id;
    return this.http.patch<any>(url, typeSupport);
  }
}
